import { Nullable } from '../types';

const compact = <T>(collection: Nullable<T>[]): T[] => {
  const results: T[] = [];

  for (const element of collection) {
    if (element != null) {
      results.push(element);
    }
  }

  return results;
};

export default compact;
